const wrapper = "cui-select-wrapper-yvno";
const base = "cui-select-7zcb";
const prefix = "cui-select-prefix-ykmo";
const icon = "cui-select-icon-8yjr";
const classes = {
  wrapper,
  base,
  "has-prefix": "cui-select-has-prefix-burn",
  prefix,
  icon
};
export {
  base,
  classes as default,
  icon,
  prefix,
  wrapper
};
